import { render, staticRenderFns } from "./suggested-knowledge.vue?vue&type=template&id=74203743&scoped=true&"
import script from "./suggested-knowledge.vue?vue&type=script&lang=js&"
export * from "./suggested-knowledge.vue?vue&type=script&lang=js&"
import style0 from "./suggested-knowledge.vue?vue&type=style&index=0&id=74203743&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74203743",
  null
  
)

export default component.exports